import type { OrderStatus } from "@khazzin/api-client";
import type { ToneMap } from "./statusTone";

/**
 * The order vocabulary both consoles draw (EP07-S01, EP10-S03): the seventeen
 * statuses in spec order and DA-07-01's colour map. The Admin Console and the
 * Store Portal read the same array, the same tones and — from the ui bundle —
 * the same `orders.status.*` labels, so a status reads identically on both.
 */

/** The seventeen, in the order an order normally moves through them (`07/01` §3.1). */
export const ORDER_STATUSES: readonly OrderStatus[] = [
	"pending",
	"fulfilling",
	"fulfilled",
	"ready_for_pickup",
	"picked_up",
	"at_delivery_warehouse",
	"delivering",
	"delivery_failed",
	"rescheduled",
	"partially_delivered",
	"delivered",
	"returning",
	"returned",
	"lost",
	"driver_payment_received",
	"completed",
	"cancelled",
];

/** The seventeen statuses' tones, registered under the `orders` domain. */
export const ORDER_STATUS_TONES: ToneMap = {
	pending: { tone: "neutral" },
	fulfilling: { tone: "info" },
	fulfilled: { tone: "info" },
	ready_for_pickup: { tone: "brand" },
	picked_up: { tone: "brand" },
	at_delivery_warehouse: { tone: "brand" },
	delivering: { tone: "brand" },
	delivery_failed: { tone: "warning", alert: true },
	rescheduled: { tone: "warning", alert: true },
	partially_delivered: { tone: "warning", alert: true },
	returning: { tone: "warning", alert: true },
	returned: { tone: "warning", alert: true },
	lost: { tone: "danger", alert: true },
	delivered: { tone: "success" },
	driver_payment_received: { tone: "success" },
	completed: { tone: "success" },
	cancelled: { tone: "danger" },
};
